import type { RouteRecordRaw } from 'vue-router'

export const adminDevicesRoutes: RouteRecordRaw[] = [
  {
    path: '/admin/devices',
    name: 'admin-devices',
    component: () => import('./pages/AdminDevicesPage.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/devices/:id',
    name: 'admin-device-detail',
    component: () => import('./pages/AdminDeviceDetailsPage.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
]
